<template>
    <div class="MAM_editInfo">
        <el-dialog :visible="infoIsShow" @close="handleClose" :close-on-click-modal="false" >
            <el-card class="box-card" shadow="hover">
                <el-form :inline="true" :model="infoForm" class="demo-form-inline">
                    <el-form-item>
                        <el-select v-model="infoForm.cashtype" clearable placeholder="请选择押金模板">
                            <el-option
                                    v-for="(item,index) in cashList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.brand_reward_conf_id"
                            ></el-option>
                        </el-select>
                        <el-select v-model="infoForm.flowtype" clearable placeholder="请选择流量卡模板">
                            <el-option
                                    v-for="(item,index) in flowList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.brand_reward_conf_id"
                            ></el-option>
                        </el-select>
                        <el-button
                                type="primary"
                                @click="handleSubmit(infoForm)"
                                :loading="submitLoading"
                        >修改</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "MAM_editInfo",
        props: {
            idsArray:{
                type:Array,
                default: function () {
                    return  [];
                }
            },
            brandidsArray:{
                type:Array,
                default: function () {
                    return  [];
                }
            },
            isactiveArray:{
                type:Array,
                default: function () {
                    return  [];
                }
            },
            isbindArray:{
                type:Array,
                default: function () {
                    return  [];
                }
            },
            useridArray:{
                type:Array,
                default: function () {
                    return  [];
                }
            },
            infoIsShow: {
                type: Boolean,
                default: false
            },
            detail: {
                type: Object
            },
            isShowRate: {
                type: Boolean,
                default: false
            },
            publickData: {
                type: Object
            },
            canSet: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                transctionInfoTable: [], //表格
                cashList: [],//押金模板
                flowList: [],//押金模板
                infoForm: {
                    cashtype: '', //押金模板id
                    flowtype: '', //流量卡模板id
                    ids: '', //终端id 数组
                },
                baseOrRise: 'base', //基础费率or涨价后费率
                baseActiveName: '1', //基础费率 - Tab默认选中
                baseTabContent: [], //基础费率 -tab内容
                baseOldData: [], //基础费率 - 旧数据(对比使用)
                riseActiveName: '1',//涨价后费率 - Tab默认选中
                riseTabContent: [], //涨价后费率 -tab内容
                riseOldData: [], //涨价后费率 - 旧数据(对比使用)
                isEdit: 0, //是否可以编辑 1是 0否
                btnLoading: false,
                level: sessionStorage.getItem('level'),
                viewData: {},
                loading: true,
                submitLoading: false,
            }
        },
        mounted() {
            this.getCash(); //获取押金模板
            this.getFlow(); //获取流量卡模板
            // this.getBaseRate(); //基础费率
            var arr = [];

        },
        methods: {
            /*handleSubmit2(val, settleType) {
                console.log('2222')
                this.btnLoading = true;
                //let { brandId, userId } = this.publickData;
                let BASE_URL;
                let changeKey;
                BASE_URL = '';
                changeKey = this._.mapKeys(this.baseOldData, (value) => {
                            return value.settle_type;
                });
                let dataSource = changeKey[settleType]; //T0 or T1
                let reqList = []; //请求的list
                let reqData = { //请求的数据
                    brand_id: 24,
                    ally_user_id: 491,
                    data:'',
                };
                this._.forEach(val, (v, i) => {
                    let child = [];
                    let dataVal = dataSource.list[i];
                    this._.forEach(v.list, (item, index) => {
                        let dataNew = dataVal.list[index];
                        if (item.value != '') {
                            if (dataNew.value != item.value) {
                                child.push(this._.pick(item, ['type', 'value']));
                            }
                        }
                    })
                    if (child.length != 0) {
                        let vtmp = this._.cloneDeep(v);
                        vtmp.list = child;
                        reqList.push(this._.omit(vtmp, ['title']));
                    }
                });
                if (!this._.isEmpty(reqList)) {
                    reqData.data = JSON.stringify(reqList);
                }

                this.$api.post(BASE_URL, reqData, res => {
                    if (res.code == 0) {
                        this.$message.success(res.msg);
                        this.getBaseRate();
                        if (this.publickData.isRise == 1) {
                            this.getRiseRate();
                        }
                        this.btnLoading = false;
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.msg,
                            duration: 5000
                        })
                        this.btnLoading = false;
                    }
                })
            },*/
           /* getBaseRate() { //获取基础费率
                //let { brandId, userId } = this.publickData;
                this.$api.post('user_rate/user_rate_list', { brand_id: 24, ally_user_id: 491 }, res => {//24   491
                    if (res.code == 0) {
                        let data = res.data;
                        this.baseTabContent = data.list;
                        this.isEdit = data.is_edit;
                        this.baseOldData = this._.cloneDeep(data.list);
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            },*/

            handleSelectionChange(row) { //表格多选
                this.loan_ids = [];
                let count = 0;
                if (row.length != 0) {
                    this._.forEach(row, item => {
                        this.loan_ids.push(item.id);
                        count = count + Number(item.lave_money);
                    })
                }
                this.submitForm.money = count;
            },
            handleClose() {
                this.$emit('infoClose')
            },
            getCash() { //获取押金模板
                this.$api.post('terminal/get_cash_back_list', {brand_id:this.brandidsArray[0]}, res => {
                    if (res.code == 0) {
                        this.cashList = res.data.setting;
                    } else {
                        this.$message.success(res.msg);
                    }
                });
            },
            getFlow() { //获取押金模板
                this.$api.post('terminal/get_flow_back_list', {brand_id:this.brandidsArray[0]}, res => {
                    if (res.code == 0) {
                        this.flowList = res.data.setting;
                    } else {
                        this.$message.success(res.msg);
                    }
                });
            },
            handleSubmit(field) { //提交
                this.submitLoading = true;
                let that = this;
                this.$api.post('terminal_equipment/edit_terminals_Info', { ids: this.idsArray,userid:this.useridArray,brandids: this.brandidsArray,isactive: this.isactiveArray,isbind: this.isbindArray,cashtype:this.infoForm.cashtype,flowtype:this.infoForm.flowtype }, res => {
                    if (res.code == 0) {
                        //console.log(res, 'res');
                        this.$message({
                            type: 'success',
                            duration: 1500,
                            message: res.msg,
                            onClose() {
                                that.handleClose(1);
                            }
                        });
                    }else{
                        this.$message.error(res.msg);
                        //this.submitLoading = false;
                    }
                })
            },
        }
    };
</script>
<style scoped lang="scss">
    .MAM_editInfo {
        font-size: 12px;
        .el-input__inner,
        .tips {
            font-size: 12px;
        }

        .el-form-item {
            margin-bottom: 5px;
        }

        ::v-deep .el-form-item__label {
            padding: 0;
            font-size: 12px;
        }
        .titleTip {
            padding: 10px 10px;
            background-color: #ecf8ff;
            border-radius: 4px;
            font-size: 13px;
            font-weight: 700;
            border-left: 5px solid #50bfff;
            margin: 10px 0;
        }
        .title p {
            font-size: 12px;
            :first-child {
                font-weight: 700;
            }
        }
    }
    .setUserRate {
        ::v-deep .el-form-item__label {
            font-size: 12px;
            font-weight: 700;
        }
        ::v-deep .el-input__inner {
            width: 150px;
        }
        ::v-deep .el-dialog {
            height: 80%;
            .el-dialog__body {
                height: 82%;
                overflow: auto;
            }
        }
        .type_title {
            margin: 10px 0;
            font-size: 13px;
            font-weight: 700;
            border-left: 5px solid #40b8ff;
            padding: 0 0 0 10px;
        }
    }
</style>